import styled from "styled-components";
import { breakpoints } from "styles";

export const PaymentSuccessContainer = styled.div`
  @media ${breakpoints.laptop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
  }
`;

export const MessageAndImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${breakpoints.laptop} {
    justify-content: center;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
`;

export const Message = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-style: normal;
  font-weight: normal;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.brand["800"]};
  margin: 0;
  line-height: 22px;
  text-align: center;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
`;

export const PackageName = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.brand["800"]};
  margin: 0;
  line-height: 28px;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const Divider = styled.hr`
  background: ${({ theme }) => theme.colors.periwinkle["200"]};
  width: 100%;
  height: 12px;
  border: 0;
  margin: 0;
  @media ${breakpoints.laptop} {
    display: none;
  }
`;

export const PaymentSuccessImageContainer = styled.div`
  height: 160px;
  width: 160px;

  @media ${breakpoints.laptop} {
    height: 268px;
    width: 268px;
  }
`;

export const MainPageCTAInImage = styled.button`
  display: none;
  @media ${breakpoints.laptop} {
    display: unset;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSizes.xs};
    line-height: 16px;
    color: ${({ theme }) => theme.colors.brand["500"]};
    align-self: center;
    margin-top: 23px;
    background: ${({ theme }) => theme.colors.white};
    border: 0;
    cursor: pointer;
  }
`;

export const DownloadAndInformationContainerCard = styled.div`
  @media ${breakpoints.laptop} {
    max-width: 550px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 40px;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0 0 30px rgba(40, 60, 109, 0.1);
    border-radius: 10px;
  }
`;

export const DownloadAndInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  @media ${breakpoints.laptop} {
    padding: 0;
  }
`;

export const DownloadContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WhatsNext = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  text-align: center;
  @media ${breakpoints.laptop} {
    margin-bottom: 20px;
    align-self: flex-start;
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const DownloadIconAndTextContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
`;

export const DownloadTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media ${breakpoints.laptop} {
    gap: 2px;
  }
`;

export const DownloadHeading = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  margin: 0;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
`;

export const DownloadSubheading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-style: normal;
  font-weight: normal;
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral["600"]};
  margin: 0;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

export const DownloadButton = styled.button`
  padding: 12px 24px;
  background: ${({ theme }) => theme.colors.brand["500"]};
  border-radius: 6px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.white};
  border: 0;
  margin-top: 24px;
  cursor: pointer;
  @media ${breakpoints.laptop} {
    display: none;
  }
`;

export const QRCodeAndStoreButtonsContainer = styled.div`
  display: none;
  @media ${breakpoints.laptop} {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 21px;
    padding: 0;
  }
`;

export const QRCodeImageContainer = styled.div`
  height:;
  width:;

  @media ${breakpoints.laptop} {
    height: 160px;
    width: 160px;
  }
`;

export const StoreLink = styled.a`
  text-decoration: none;
`;

export const StoreButtonsAndTextContainer = styled.div`
  display: none;
  @media ${breakpoints.laptop} {
    display: flex;
    flex-direction: column;
    gap: 13px;
  }
`;

export const StoreText = styled.p`
  display: none;
  @media ${breakpoints.laptop} {
    display: unset;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-style: normal;
    font-weight: normal;
    font-size: ${({ theme }) => theme.fontSizes.sm};
    line-height: 24px;
    color: ${({ theme }) => theme.colors.neutral["600"]};
    margin: 0;
  }
`;

export const HorizontalRule = styled.hr`
  border: ${({ theme }) => `0.7px solid ${theme.colors.neutral["100"]}`};
  width: 100%;
  margin: 16px 0;
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 0;
  @media ${breakpoints.laptop} {
    gap: 24px;
  }
`;

export const Information = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 0;
`;

export const InformationTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  @media ${breakpoints.laptop} {
    gap: 2px;
  }
`;

export const InformationImageContainer = styled.div`
  height: 46px;
  width: 46px;
  position: relative;

  @media ${breakpoints.laptop} {
    height: 64px;
    width: 64px;
  }
`;

export const InformationHeading = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  margin: 0;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

export const InformationSubheading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-style: normal;
  font-weight: normal;
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  line-height: 16px;
  color: ${({ theme }) => theme.colors.neutral["600"]};
  margin: 0;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

export const MainPageCTALink = styled.a`
  align-self: center;
  text-decoration: none;
`;

export const MainPageCTAInInformation = styled.button`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  line-height: 16px;
  color: ${({ theme }) => theme.colors.brand["500"]};
  margin-top: 23px;
  background: ${({ theme }) => theme.colors.white};
  border: 0;
  cursor: pointer;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
    display: none;
  }
`;
